import * as THREE from 'three';
import Experience from './Experience.js';
import gsap from 'gsap';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

export default class Camera {
  constructor(_options) {
    // Options
    this.experience = new Experience();
    this.config = this.experience.config;
    this.debug = this.experience.debug;
    this.time = this.experience.time;
    this.targetElement = this.experience.targetElement;
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    this.height = this.experience.config.maxHeight;
    this.projectLoc = 3;
    this.backtomenu = document.getElementById('backtomenu');

    if (this.debug) {
      this.debugFolder = this.debug.addFolder({
        title: 'camera'
      });
    }

    this.setInstance();
    this.setControls();
    this.setLogic();
    this.setCamAngles();
    this.setCamControls();
    this.setTransitions();
    this.setButton();
  }

  //   controls.enableZoom = false;
  // controls.enableRotate = true;
  // controls.target = new THREE.Vector3(this.camera.position.x + 1, camera.position.y + 1, this.camera.position.z + 1)
  // controls.enablePan = true;
  // controls.panSpeed = 4000;
  // controls.keyPanSpeed = 26000;
  // controls.maxDistance = 2000;

  setInstance() {
    this.pov = this.config.width > 600 ? 75 : 100;
    console.log(this.config.width);
    // Set up
    this.instance = new THREE.PerspectiveCamera(
      this.pov,
      this.config.width / this.config.height,
      1,
      1000
    );
    this.instance.rotation.reorder('YXZ');
    this.instance.layers.enableAll();
    this.instance.position.set(20, 5, 9.7);
    this.scene.add(this.instance);
  }

  //need fix
  setLogic() {
    this.logic = {};
    this.logic.buttonsLocked = false;
    this.logic.mode = 'menu';
    this.logic.lockButtons = async (lockDuration) => {
      this.logic.buttonsLocked = true;
      await this.sleep(lockDuration);
      this.logic.buttonsLocked = false;
    };
  }

  setControls() {
    this.controls = new OrbitControls(this.instance, this.targetElement);
    // this.controls.rotateSpeed = 0.8
    // this.controls.zoomSpeed = 0.8
    this.controls.maxPolarAngle = 1.54; //vertical
    // this.controls.minPolarAngle = -Math.PI /8;
    this.controls.minPolarAngle = 0.5;
    this.controls.maxAzimuthAngle = Math.PI / 3; // orizontal
    this.controls.minAzimuthAngle = -0.2;
    // this.controls.maxDistance = 20;
    // this.controls.minDistance = 10;

    this.controls.enableRotate = true;
    this.controls.enableZoom = true;
    this.controls.enablePan = false;
    // this.controls.enabled = this.modes.debug.active
    // this.controls.screenSpacePanning = true;
    this.controls.enableKeys = false;
    this.controls.zoomSpeed = 1;
    this.controls.enableDamping = true;
    this.controls.target.x = 5;
    this.controls.target.y =
      this.experience.sizes.mode === 'smallScreen' ? 1.0 : 0.9;
    this.controls.target.z = -4.3;
    this.controls.update();

    if (this.debug) {
      this.debugFolder
        .addInput(this.instance.position, 'x', {
          label: 'posx',
          min: -40,
          max: 40,
          step: 0.1
        })
        .on('change', () => {
          this.controls.update();
        });
      this.debugFolder
        .addInput(this.instance.position, 'y', {
          label: 'posy',
          min: -40,
          max: 40,
          step: 0.1
        })
        .on('change', () => {
          this.controls.update();
        });
      this.debugFolder
        .addInput(this.instance.position, 'z', {
          label: 'posz',
          min: -40,
          max: 40,
          step: 0.1
        })
        .on('change', () => {
          this.controls.update();
        });
      this.debugFolder
        .addInput(this.controls.target, 'x', {
          label: 'targetx',
          min: -40,
          max: 40,
          step: 0.1
        })
        .on('change', () => {
          this.controls.update();
        });
      this.debugFolder
        .addInput(this.controls.target, 'y', {
          label: 'targety',
          min: -40,
          max: 40,
          step: 0.1
        })
        .on('change', () => {
          this.controls.update();
        });
      this.debugFolder
        .addInput(this.controls.target, 'z', {
          label: 'targetz',
          min: -40,
          max: 40,
          step: 0.1
        })
        .on('change', () => {
          this.controls.update();
        });
    }
  }

  setCamAngles() {
    this.camAngle = {};

    this.camAngle.unlocked = () => {
      // this.controls.target.x = 0;
      // this.controls.target.y = 0;
      // this.controls.target.z = 0;
      this.controls.maxDistance = 20;
      this.controls.minDistance = 10;
      this.controls.minAzimuthAngle = 0;
      this.controls.maxAzimuthAngle = Math.PI * 1.999;
      this.controls.minPolarAngle = 0;
      this.controls.maxPolarAngle = Math.PI;
    };

    this.camAngle.default = () => {
      this.controls.minDistance = 8;
      this.controls.maxDistance = 16;
      this.controls.minAzimuthAngle = -0.2;
      this.controls.maxAzimuthAngle = Math.PI / 3;
      this.controls.minPolarAngle = 0.5;
      this.controls.maxPolarAngle = 1.54;
      this.controls.enableRotate = true;
      this.controls.enableZoom = true;
    };

    this.camAngle.skills = () => {
      this.controls.minAzimuthAngle = 0.5;
      this.controls.maxAzimuthAngle = 2;
      this.controls.minPolarAngle = 0.487;
      this.controls.maxPolarAngle = 1.429;
      this.controls.minDistance = 5;
      this.controls.maxDistance = 10;
      this.controls.enableRotate = true;
      this.controls.enableZoom = true;
    };

    this.camAngle.projects = () => {
      console.log('projects camera angle');
    };

    this.camAngle.contact = () => {
      this.controls.enableRotate = false;
      this.controls.enablePan = false;
      this.controls.minDistance = 8;
      this.controls.maxDistance = 12;
    };
  }

  setCamControls() {
    this.camControls = {};

    this.camControls.toDefault = async () => {
      if (this.logic.buttonsLocked === false) {
        if (this.logic.mode === 'projects') {
          this.experience.world.dungeon.removeProjectVisibility();
        }
        this.backtomenu.classList.remove('show');
        this.logic.mode = 'menu';
        this.logic.lockButtons(1600);
        this.camAngle.unlocked();
        this.transitions.default(1.5);
        await this.sleep(1500);
        this.camAngle.default();
        this.experience.world.raycasterObjects.contactBox.layers.set(1);
        this.experience.world.raycasterObjects.skillsBox.layers.set(1);
        this.experience.world.raycasterObjects.projectsBox.layers.set(1);
      }
    };

    this.camControls.toSkills = async () => {
      if (this.logic.buttonsLocked === false && this.logic.mode === 'menu') {
        this.logic.mode = 'skills';
        window.location.hash = '#skills';
        this.logic.lockButtons(3100);
        this.camAngle.unlocked();
        this.transitions.skills(3);
        await this.sleep(3000);
        this.camAngle.skills();
        this.disableBigOnes();
        this.backtomenu.classList.add('show');
      }
    };

    this.camControls.toProjects = async () => {
      if (this.logic.buttonsLocked === false && this.logic.mode === 'menu') {
        this.logic.mode = 'projects';
        window.location.hash = '#projects';
        this.logic.lockButtons(2500);
        this.camAngle.unlocked();
        this.transitions.projects(2);
        await this.sleep(2000);
        this.camAngle.projects();
        this.experience.world.dungeon.setProjectVisibility();
        this.disableBigOnes();
        this.backtomenu.classList.add('show');
      }
    };
    this.camControls.toContact = async () => {
      if (this.logic.buttonsLocked === false && this.logic.mode === 'menu') {
        this.logic.mode = 'contact';
        window.location.hash = '#contact';
        this.logic.lockButtons(2500);
        this.camAngle.unlocked();
        this.transitions.contact(2);
        await this.sleep(2000);
        this.camAngle.contact();
        this.disableBigOnes();
        this.backtomenu.classList.add('show');
      }
    };
  }
  disableBigOnes() {
    this.experience.world.raycasterObjects.contactBox.layers.set(9);
    this.experience.world.raycasterObjects.skillsBox.layers.set(9);
    this.experience.world.raycasterObjects.projectsBox.layers.set(9);
  }
  setTransitions() {
    this.transitions = {};

    /* ************
     ***  Menu  ****
     **************/
    this.transitions.default = async (duration) => {
      gsap.to(this.instance.position, {
        duration: duration,
        ease: 'power1.inOut',
        x: 5,
        y: 5,
        z: 9.7
      });

      gsap.to(this.controls.target, {
        duration: duration,
        ease: 'power1.inOut',
        x: 5,
        y: this.experience.sizes.mode === 'smallScreen' ? 1.0 : 0.9,
        z: -4.3
      });
    };

    /* ****************
     ***  Skills  ****
     ******************/

    this.transitions.skills = async (duration) => {
      gsap.to(this.instance.position, {
        duration: duration,
        ease: 'power1.inOut',
        x: 8.4,
        y: 4,
        z: 1
      });

      gsap.to(this.controls.target, {
        duration: duration,
        ease: 'power1.inOut',
        x: -1,
        y: 1,
        z: 0
      });
    };
    /* ***************
     ***  Projects  ****
     *****************/
    this.transitions.projects = async (duration) => {
      this.controls.enableRotate = false;
      this.controls.enableZoom = false;
      if (this.experience.sizes.mode === 'bigScreen') {
        gsap.to(this.instance.position, {
          duration: duration,
          ease: 'power1.inOut',
          x: 9.9,
          y: 1.4,
          z: -3.4
        });

        gsap.to(this.controls.target, {
          duration: duration,
          ease: 'power1.inOut',
          x: 16.6,
          y: 1.4,
          z: -19.3
        });
      } else if (this.experience.sizes.mode === 'smallScreen') {
        gsap.to(this.instance.position, {
          duration: duration,
          ease: 'power1.inOut',
          x: 9.7,
          y: 1.7,
          z: -4.6
        });

        gsap.to(this.controls.target, {
          duration: duration,
          ease: 'power1.inOut',
          x: 13.8,
          y: 1.7,
          z: -14.5
        });
      }
    };
    this.transitions.contact = async (duration) => {
      if (this.experience.sizes.mode === 'bigScreen') {
        gsap.to(this.instance.position, {
          duration: duration,
          ease: 'power1.inOut',
          x: 3.1,
          y: 3.1,
          z: -5.2
        });

        gsap.to(this.controls.target, {
          duration: duration,
          ease: 'power1.inOut',
          x: 3.2,
          y: 3.1,
          z: -17.0
        });
      } else if (this.experience.sizes.mode === 'smallScreen') {
        gsap.to(this.instance.position, {
          duration: duration,
          ease: 'power1.inOut',
          x: 2.9,
          y: 3.1,
          z: -5.2
        });

        gsap.to(this.controls.target, {
          duration: duration,
          ease: 'power1.inOut',
          x: 2.9,
          y: 3.1,
          z: -17.0
        });
      }
    };
  }

  setButton() {
    this.backtomenu.addEventListener('click', () => {
      history.back();
      this.camControls.toDefault();
    });
  }
  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  resize() {
    this.instance.aspect = this.config.width / this.config.height;
    this.instance.updateProjectionMatrix();
  }

  update() {
    // Update debug orbit controls
    this.controls.update();

    // Apply coordinates
    this.instance.updateMatrixWorld(); // To be used in projection
  }

  destroy() {
    this.modes.debug.orbitControls.destroy();
  }
}
